import { render, staticRenderFns } from "./VideoYoutube.vue?vue&type=template&id=2db5a023&scoped=true"
import script from "./VideoYoutube.vue?vue&type=script&lang=js"
export * from "./VideoYoutube.vue?vue&type=script&lang=js"
import style0 from "./VideoYoutube.vue?vue&type=style&index=0&id=2db5a023&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5a023",
  null
  
)

export default component.exports